import { render, staticRenderFns } from "./GroupSettings.vue?vue&type=template&id=56755ffa&scoped=true"
import script from "./GroupSettings.vue?vue&type=script&lang=js"
export * from "./GroupSettings.vue?vue&type=script&lang=js"
import style0 from "./GroupSettings.vue?vue&type=style&index=0&id=56755ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56755ffa",
  null
  
)

/* custom blocks */
import block0 from "./GroupSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports